export class SecretRefGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecretRefGcp.attributeTypeMap;
    }
    constructor() {
    }
}
